module.exports = __webpack_public_path__ + "img/wap_xen3.5f6de283.jpg";